<template>
  <h1></h1>
  <h3></h3>
</template>

<script>
export default {
  name: 'MerchantDescription'
}
</script>
